const statementsEnrollmentUrl = "v1/credit/accounts/statements/enrollment";
export {
  statementsEnrollmentUrl
};
//# sourceMappingURL=endpoints.js.map
